import get from 'lodash/get';
import { combineReducers } from 'redux';

import { getFiltersAppliedFromValidQueryParams } from '../../../pages/Tasks/ShortenerResolution/shortenerResolutionFiltersHelpers';
import * as fromCloseLink from './closeLink';
import closeLink from './closeLink';
import * as fromDelayLink from './delayLink';
import delayLink from './delayLink';
import * as fromDomains from './domains';
import domains from './domains';
import filters from './filters';
import * as fromLinkToResolve from './linkToResolve';
import linkToResolve from './linkToResolve';
import * as fromResolveLink from './resolveLink';
import resolveLink from './resolveLink';
import targetLink from './targetLink';

const shortenerResolution = combineReducers({
  targetLink,
  closeLink,
  delayLink,
  domains,
  linkToResolve,
  resolveLink,
  filters,
});

export default shortenerResolution;

const getShortenerResolution = state => state.tasks.shortenerResolution;

export const getShortenerResolutionDomains = state =>
  fromDomains.getShortenerResolutionDomains(
    getShortenerResolution(state).domains
  );

export const getShortenerResolutionDomainsIsLoading = state =>
  getShortenerResolution(state).domains.isLoading;

export const getShortenerResolutionDomainsIsLoaded = state =>
  !getShortenerResolution(state).domains.isLoading &&
  getShortenerResolution(state).domains.response.status != null;

export const getShortenerResolutionFiltersSelected = state =>
  getShortenerResolution(state).filters.selected;

export const getShortenerResolutionLinkToResolve = state =>
  fromLinkToResolve.getShortenerResolutionLinkToResolve(
    getShortenerResolution(state).linkToResolve
  );

export const getShortenerResolutionResolveLinkIsSuccess = state =>
  fromResolveLink.getShortenerResolutionResolveLinkIsSuccess(
    getShortenerResolution(state).resolveLink
  );

export const getShortenerResolutionCloseLinkIsSuccess = state =>
  fromCloseLink.getShortenerResolutionCloseLinkIsSuccess(
    getShortenerResolution(state).closeLink
  );

export const getShortenerResolutionDelayLinkIsSuccess = state =>
  fromDelayLink.getShortenerResolutionDelayLinkIsSuccess(
    getShortenerResolution(state).delayLink
  );

export const getShortenerResolutionNoMoreLinksToResolve = state =>
  fromLinkToResolve.getShortenerResolutionNoMoreLinksToResolve(
    getShortenerResolution(state).linkToResolve
  );

export const getShortenerResolutionFiltersApplied = (state, queryParams) => {
  const {
    filterByCustomer: selectedFilterByCustomer,
  } = getShortenerResolutionFiltersSelected(state);

  return getFiltersAppliedFromValidQueryParams({
    availableDomains: getShortenerResolutionDomains(state),
    queryParams,
    selectedFilterByCustomer,
  });
};

export const getShortenerResolutionSelectedTargetLink = state =>
  get(state, 'tasks.shortenerResolution.targetLink', null);

export const getShortenerResolutionLinkToResolveIsLoading = state =>
  get(state, 'tasks.shortenerResolution.linkToResolve.isLoading', false);

export const getShortenerResolutionCloseLinkIsLoading = state =>
  get(state, 'tasks.shortenerResolution.closeLink.isLoading', false);

export const getShortenerResolutionDelayLinkIsLoading = state =>
  get(state, 'tasks.shortenerResolution.delayLink.isLoading', false);

export const getShortenerResolutionResolveLinkIsLoading = state =>
  get(state, 'tasks.shortenerResolution.resolveLink.isLoading', false);

export const getShortenerResolutionActionsAreLoading = state =>
  getShortenerResolutionCloseLinkIsLoading(state) ||
  getShortenerResolutionDelayLinkIsLoading(state) ||
  getShortenerResolutionResolveLinkIsLoading(state);
